import React, {Component} from "react";

function Product(props) {
	let product = props.value;

	function convertGramsToLbs(grams) {
		if (grams < 1000) {
			return grams + ' grams';
		} else {
			return Math.round(grams *  0.2204623) / 100 + ' lbs';
		}
	}

	function convertGramsToKgs(grams) {
		if (grams < 1000) {
			return grams + ' grams';
		} else {
			return (grams / 1000) + ' kg';
		}
	}

	let weight = "";
	if (product.weight > 0) {
		weight = (<div className="weight">{convertGramsToKgs(product.weight)}</div>);
	}

	return (
		<section className="column">
			<div className="productBox">
				<a href={product.url} className="imageLink">
					<img width="488" height="301" src={product.coverUrl} alt={(product.cover !== null) ? product.cover.description : ''}/>
				</a>
				<div className="productBoxContent">
					<a href={product.url}>
						<h4>
							<span>{product.name}</span><br/>
							<span className={product.isSpecialPrice ? "price specialPrice" : "price"}>{product.priceHtml}</span>
						</h4>
					</a>
					{weight}
				</div>
			</div>
		</section>);
}

export default Product;
